export default "__VITE_ASSET__HjCIJMva__"